import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { computed, type PropType } from 'vue';

import { usePromiseThrowing } from '@exchange/libs/composables/shared/src/lib/usePromise';
import { modalVariant, type ModalVariant } from '@exchange/libs/modals/src';
import { logger } from '@exchange/libs/utils/simple-logger/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'NativeAppUpdateAvailable',
  props: {
  confirm: { type: Function as PropType<() => Promise<void>>, required: true },
  cancel: { type: Function as PropType<() => Promise<void>>, required: true },
  canClose: { type: Boolean, default: false },
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.dark },
},
  setup(__props) {

const props = __props;

const { loading: canceling, createPromise: cancelUpdate } = usePromiseThrowing(async () => {
  await props.cancel().catch((e) => {
    logger.error('Native update cancellation failed', e);
  });
});

const { loading: confirming, createPromise: confirmUpdate } = usePromiseThrowing(async () => {
  await props.confirm().catch((e) => {
    logger.error('Native update confirmation failed', e);
  });
});

const disableButtonActions = computed(() => canceling.value || confirming.value);

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!
  const _component_x_modal = _resolveComponent("x-modal")!

  return (_openBlock(), _createBlock(_component_x_modal, {
    class: "native-app-update-available",
    type: "info",
    variant: __props.variant,
    title: _ctx.$t('modules.nativeApps.updateAvailable.title'),
    "can-close": __props.canClose,
    onModalClose: _unref(cancelUpdate)
  }, {
    content: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('modules.nativeApps.updateAvailable.message')), 1)
    ]),
    buttons: _withCtx(() => [
      (__props.canClose)
        ? (_openBlock(), _createBlock(_component_x_button, {
            key: 0,
            variant: "outline",
            text: _ctx.$t('modules.nativeApps.updateAvailable.cancel'),
            loading: _unref(canceling),
            disabled: disableButtonActions.value,
            onClick: _unref(cancelUpdate)
          }, null, 8, ["text", "loading", "disabled", "onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_x_button, {
        variant: "primary",
        loading: _unref(confirming),
        disabled: disableButtonActions.value,
        text: _ctx.$t('modules.nativeApps.updateAvailable.confirm'),
        onClick: __props.confirm
      }, null, 8, ["loading", "disabled", "text", "onClick"])
    ]),
    _: 1
  }, 8, ["variant", "title", "can-close", "onModalClose"]))
}
}

})